import "./styles/style.css"
import "./styles/mediaQuery.css"
import React, { useState, useEffect } from 'react';
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./components/Home";
import About from "./components/About";
import Services from "./components/Services";
import Resume from "./components/Resume";
import Contact from "./components/Contact";
import { Route, Routes } from "react-router-dom";
import ErrorPage from "./components/ErrorPage";

function App() {

  const [isOnline, setIsOnline] = useState(window.navigator.onLine);
  const [wasOffline, setWasOffline] = useState(false);

  useEffect(() => {
    // Add an event listener to monitor changes in online status
    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);

    return () => {
      // Remove the event listeners when the component unmounts
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, []);

  // Check if the user was previously offline and is now online
  if (wasOffline && isOnline) {


    // Create a new <div> element
    const statusDiv = document.createElement('div');

    // Set the text content
    statusDiv.textContent = "You're online now";

    // Apply styles
    statusDiv.style.position = 'fixed';
    statusDiv.style.bottom = '0';
    statusDiv.style.width = '100%';
    statusDiv.style.padding = '3px';
    statusDiv.style.backgroundColor = '#00f100'; // You can change this to your desired background color
    statusDiv.style.color = 'white'; // Text color
    statusDiv.style.textAlign = 'center';
    statusDiv.style.zIndex = "1000000000000";
    statusDiv.style.userSelect = "none";
    statusDiv.style.fontSize = "0.8em";

    // Append the <div> to the body of the document
    document.body.appendChild(statusDiv);

    // Set a timeout to change opacity after 2000 milliseconds (2 seconds)
    setTimeout(() => {
      statusDiv.style.opacity = '0';
      // Add a CSS transition for a smooth opacity change
      statusDiv.style.transition = 'opacity 1s ease-in-out';
    }, 2000);
  }

  const handleOnlineStatusChange = () => {
    setIsOnline(window.navigator.onLine);
    if (!window.navigator.onLine) {
      setWasOffline(true);
    }
  };


  if (!isOnline) {
    document.title = "Portfolio - OFFLINE"
  }

  return (
    <div className="App">
      {isOnline ?
        <>
          <Navbar />
          <Routes>
            <Route path="/" exact element={<Home />} />
            <Route path="/about" exact element={<About />} />
            <Route path="/resume" exact element={<Resume />} />
            <Route path="/services" exact element={<Services />} />
            <Route path="/contact" exact element={<Contact />} />
            <Route path="*" element={<ErrorPage />} />
          </Routes>
          <Footer />
        </>
        :
        <div className="offline" style={{ width: "100vw", height: "100vh", backgroundColor: '#fff', zIndex: 20, position: "relative" }}>
          <svg width="180" height="150" fill="none" xmlns="http://www.w3.org/2000/svg"><title>Books on a shelf</title><path d="M84.53 135.29H111.27L111.64 119.93L108.84 119.92L84.53 135.29Z" fill="#3C4043" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M11.0701 135.29H16.3701V80.81L11.0701 135.29Z" fill="#3C4043"></path><path d="M38.21 135.29H43.04V80.81L38.21 135.29Z" fill="#3C4043"></path><path d="M4.5 135.29H174.58" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round"></path><path d="M73.8002 45.5H54.6602V135.29H73.8002V45.5Z" fill="white" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M68.8401 118.66H59.6201V130H68.8401V118.66Z" fill="#DADCE0" stroke="#DADCE0" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M67.0302 55.81H61.4202V67.15H67.0302V55.81Z" fill="#DADCE0" stroke="#DADCE0" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M61.4202 80.21V111.7" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M67.0403 92.91V111.7" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M35.5101 78.94H16.3701V135.29H35.5101V78.94Z" fill="white" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M35.5101 122.68H16.3701V127.71H35.5101V122.68Z" fill="#DADCE0" stroke="#DADCE0" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M35.5101 78.94H16.3701V135.29H35.5101V78.94Z" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M54.6501 65.1H43.0601V135.29H54.6501V65.1Z" fill="white" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M54.6501 76.37H43.0601V124.03H54.6501V76.37Z" fill="#DADCE0"></path><path d="M54.6501 65.1H43.0601V135.29H54.6501V65.1Z" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M48.8601 92.23V118.07" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M167.992 135.297V119.927L111.642 119.927V135.297H167.992Z" fill="white" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M158.762 135.297V119.927H120.862V135.297H158.762Z" fill="#DADCE0" stroke="#DADCE0" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M167.992 135.297V119.927L111.642 119.927V135.297H167.992Z" stroke="#3C4043" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M111.64 128.8V119.92H145.7L111.64 128.8Z" fill="#3C4043"></path><path d="M144.861 98.3175L138.765 88.0503L78.4089 123.882L84.5043 134.15L144.861 98.3175Z" fill="#EA4335" stroke="#EA4335" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M139.882 101.273L133.786 91.0061L83.3878 120.927L89.4831 131.194L139.882 101.273Z" stroke="#EA4335" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M118.49 107.03L96.27 120.22" stroke="white" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M139.881 101.265L133.785 90.9982L129.46 93.566L135.555 103.833L139.881 101.265Z" fill="white" stroke="#EA4335" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path><path d="M93.8046 128.625L87.7092 118.358L83.3839 120.926L89.4793 131.193L93.8046 128.625Z" fill="white" stroke="#EA4335" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path></svg>
          <h1>Ooops!</h1>
          <p>You are offline. Please check your internet connection.</p>
        </div>
      }
    </div>
  );
}

export default App;
